import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const ServicePrLisitng = ({
  getPrListingWithPo,
  prListData,
  getGOLiveFilterDropDown,
  liveFilterDropDown,
}) => {
  const headers = [
    'PR Number',
    'Site Number',
    'PR Type',
    'Site Name',
    'PO Number',
    'Vendor',
    'Status',
    'PR Amount',
    'Raised By',
    'Creation Date',
    'Action'
  ]
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("mainSiteCont") &&
        localStorage.getItem("mainSiteCont")
    );
    if(installationCont){
      localStorage.setItem("mainGoLive", JSON.stringify(""));
      localStorage.setItem("mainSiteCont", 0);
    }
    
  }, []);

  useEffect(() => {
    if (getPrListingWithPo !== null)
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("mainGoLive") &&
            localStorage.getItem("mainGoLive")
        );
        setIsLoading(true);
        if(getcontractFilter){
          await getPrListingWithPo(getcontractFilter);
        }else{
         await getPrListingWithPo();
        }
        setIsLoading(false);
      })();
  }, [getPrListingWithPo]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("mainGoLive", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getPrListingWithPo(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'pr_type',
      'site_name',
      'po_number',
      'firm_name',
      'status_text',
      'total_amount',
      'user_name',
      'created_at'
    ];
    console.log('000 ' + JSON.stringify(prListData));
    if (prListData && prListData.data) {
      const data = prListData.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          (element['po_number'] != null && element['pr_vendor_id'] != null) ?
          {
            Action: [
              {
                name: 'PR Confirmation',
                link: `/dashboard/pr-confirmation/${element.pr_vendor_id}`,
              },
              {
                name: 'View Details',
                link: `/dashboard/pr-confirmation-details`,
              }
            ],
          }:{
            Action:[{
              name: 'View Details',
              link: `/dashboard/pr-confirmation-details`,
            }]
          }
        )
      );
      setListData(data);
      setPageCount(Math.ceil(prListData.total / prListData.per_page));
    }
  }, [prListData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getPrListingWithPo(filterData,val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.servicePrList}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={prListData?.from}
        onPageChange={onPageChange}
        detailList={prListData && prListData.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={
          liveFilterDropDown?.site_type ? liveFilterDropDown : null
        }
        servicePrFilters
      />
    </Layout>
  );
};
export default ServicePrLisitng;
